import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "../../store";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// returns a reference to the dispatch function from the Redux store
export const useAppDispatch: () => AppDispatch = useDispatch;
// extract data from the Redux store state
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
